import { render } from "./BaseInformation.vue?vue&type=template&id=bf7d7740&scoped=true"
import script from "./BaseInformation.vue?vue&type=script&lang=js"
export * from "./BaseInformation.vue?vue&type=script&lang=js"

import "./BaseInformation.vue?vue&type=style&index=0&id=bf7d7740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf7d7740"]])

export default __exports__